export default {
  data() {
    return {
      orderId: "",
      visible: false,
    };
  },
  methods: {
    open(orderId) {
      this.orderId = orderId;
      this.visible = true;
    },
    selected(type) {
      this.$router.push({
        path: "/seller/logistics",
        query: { orderId: this.orderId, type },
      });
      // this.$open(`/seller/logistics?orderId=${this.orderId}&type=${type}`, { target: 1 });
    },
  },
};
